import { render, staticRenderFns } from "./admin_cuatrimestre.vue?vue&type=template&id=4c639d1e&"
import script from "./admin_cuatrimestre.vue?vue&type=script&lang=js&"
export * from "./admin_cuatrimestre.vue?vue&type=script&lang=js&"
import style0 from "./admin_cuatrimestre.vue?vue&type=style&index=0&id=4c639d1e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports